var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserProfile = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.90909 3.50483C7.90909 4.52503 7.05436 5.43745 6 5.43745C4.94564 5.43745 4.09091 4.52503 4.09091 3.50483C4.09091 2.48462 4.94564 1.5 6 1.5C7.05436 1.5 7.90909 2.48462 7.90909 3.50483Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 8.38894C10.5 9.55489 9.13636 10.5001 6 10.5001C2.86364 10.5001 1.5 9.55489 1.5 8.38894C1.5 7.22299 3.51472 6.2778 6 6.2778C8.48528 6.2778 10.5 7.22299 10.5 8.38894Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserProfile);
export default ForwardRef;